var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCircledCheck = function SvgIconCircledCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8 1a7 7 0 1 0 7 7 7.007 7.007 0 0 0-7-7m0 12.833A5.833 5.833 0 1 1 13.833 8 5.84 5.84 0 0 1 8 13.833"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m7.048 8.843-1.274-1.38a.68.68 0 0 0-.518-.227.74.74 0 0 0-.546.244.86.86 0 0 0-.21.577q0 .332.226.559l1.774 1.94a.73.73 0 0 0 .544.244.76.76 0 0 0 .553-.245l3.661-3.983a.79.79 0 0 0 .242-.57.83.83 0 0 0-.242-.583.7.7 0 0 0-.542-.219.76.76 0 0 0-.539.236z"
  })));
};
export default SvgIconCircledCheck;